// extracted by mini-css-extract-plugin
export default {"details":"styles_details__Rj6p4","detail":"styles_detail__q93T2","imageWrapper":"styles_imageWrapper__vGiaS"};